import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createMoveReleaseToIndexCommand } from '../../../api/commands/factory/createReleaseCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class MoveRelease extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'MoveRelease';

    public constructor(public id: string, public order: number) {
        super(MoveRelease.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: MoveRelease): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createMoveReleaseToIndexCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: MoveRelease): void => {
    const release = state.releases.find((x) => x.id === action.id);

    state.releases.filter((x) => x.order > release.order).forEach((x) => x.order--);

    state.releases.filter((x) => x.order >= action.order).forEach((x) => x.order++);

    release.order = action.order;
};

//@ts-ignore
registerMiddleware(MoveRelease.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(MoveRelease.ACTION_TYPE, reducer);
